module.exports = __webpack_public_path__ + "img/nodata.fb7ed82a.png";